
import WifiNetworks from 'src/components/WifiNetworks'

const Page = () => {
  return (
    <>
      <WifiNetworks type='google-cloud' />
    </>
  )
}

export default Page
